import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { ContainerOccupancyEmptyFullRate } from 'app/models/container-occupancy-empty-full-rate.model';
import { ContainerOccupancyReport, StartEndDate } from 'app/models/container-occupancy-report.model';
import { RoutingSimulationReport } from 'app/models/routingSimulation.model';
import { SetGeneralZone } from 'app/models/set-general-zone.model';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ReportingService {

    containerOccupancyReport: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getContainerUnloadingStatus(companyId: number, start, end): Promise<Array<ContainerOccupancyReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/ContainerUnloadingStatus/" + companyId, sed)
                .subscribe((response: any) => {
                    this.containerOccupancyReport = response;
                    this.onChanged.next(this.containerOccupancyReport)
                    resolve(response);
                }, reject);
        });
    }
    getContainerUnloadingEmptyFullRate(companyId: number, start, end): Promise<Array<ContainerOccupancyEmptyFullRate>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/ContainerUnloadingEmptyFullRate/" + companyId, sed)
                .subscribe((response: any) => {
                    this.containerOccupancyReport = response;
                    this.onChanged.next(this.containerOccupancyReport)
                    resolve(response);
                }, reject);
        });
    }

    getRoutingSimulation(polygonId: number, startDate: Date, endDate: Date, lat: number, lng: number): Promise<Array<RoutingSimulationReport>> {
        var sed = new StartEndDate();
        var params = new HttpParams();
        params = params.append('latitude', lat.toString())
        params = params.append('longitude', lng.toString())
        sed.endTime = endDate;
        sed.startTime = startDate;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/RoutingSimulationReport/" + polygonId, sed, { params: params })
                .subscribe((response: any) => {
                    this.containerOccupancyReport = response;
                    this.onChanged.next(this.containerOccupancyReport)
                    resolve(response);
                }, reject);
        });
    }

    setGeneralZoneReport(setGeneralZone:SetGeneralZone): Promise<Array<SetGeneralZone>> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/SetGeneralZoneReport",setGeneralZone)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
